import { Navigate } from "react-router-dom";
import { useAdminAuth } from "@/context/AdminAuthContext";

export default function ProtectedAdminRoute({ children }) {
  const { user, loading } = useAdminAuth();
  if (loading) {
    return (
      <div className="min-h-screen grid place-items-center bg-ih-ink text-white/60">
        <div className="flex items-center gap-3">
          <span className="w-2 h-2 rounded-full bg-ih-neon animate-pulse-glow" />
          <span className="font-mono text-xs uppercase tracking-[0.2em]">Authenticating</span>
        </div>
      </div>
    );
  }
  if (!user) return <Navigate to="/admin/login" replace />;
  return children;
}
